import { render, staticRenderFns } from "./InputIntegerNumber.vue?vue&type=template&id=ce5b2c64"
import script from "./InputIntegerNumber.vue?vue&type=script&lang=js"
export * from "./InputIntegerNumber.vue?vue&type=script&lang=js"
import style0 from "./InputIntegerNumber.vue?vue&type=style&index=0&id=ce5b2c64&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports